import { render, staticRenderFns } from "./ContactsModal.vue?vue&type=template&id=391905e2&scoped=true&"
import script from "./ContactsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ContactsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391905e2",
  null
  
)

export default component.exports